import { SetRoutes } from 'components';
import routes from './routes';

const ShoppingCenterPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default ShoppingCenterPages;
